import { Assets } from "../Assets";
import "../Direction";
/**
 * Represents equipment on top of a bench.
 */
export function Benchtop(base) {
    return class extends base {
        constructor(...args) {
            super(...args);
            const bench = Assets.objects.Bench.clone();
            this.model.add(bench);
        }
    };
}
